export default __webpack_public_path__ + "static/media/experts-panel-top-image.6205e3f7.jpeg";